import React from "react";
import { useAccessToken } from "../hooks/useAuthentication";
import { SafeVault, Candlestick } from "./StockIcons";

const LoginRequired: React.FC = () => {
  const { instance, accounts } = useAccessToken();
  console.log(accounts);

  return (
    <div className="min-h-screen bg-qw-dark flex items-center justify-center">
      <div className="text-center max-w-sm">
        {/* Wordmark */}
        <div className="mb-12">
          <div className="flex items-center justify-center gap-3 mb-3">
            <Candlestick className="w-10 h-10 text-qw-teal" bullish={true} />
          </div>
          <h1 className="font-montserrat font-extrabold text-white text-2xl tracking-[3px] uppercase">
            Q Wealth Partners
          </h1>
          <p className="font-montserrat font-normal text-qw-silver text-[10px] tracking-[5px] uppercase mt-1">
            Where Money Meets Meaning
          </p>
        </div>

        {/* Theme-independent: this branded white card always sits on the dark
            brand background, so it uses fixed light literals rather than the
            theme tokens (which would turn it dark-on-dark in dark mode). */}
        <div className="bg-white rounded-qw-lg border border-qw-mist shadow-sm p-10">
          <div className="w-16 h-16 rounded-full bg-qw-mist flex items-center justify-center mx-auto mb-6">
            <SafeVault className="w-9 h-9 text-qw-charcoal" />
          </div>
          <h2 className="font-montserrat font-bold text-qw-black text-lg mb-2">Sign In Required</h2>
          <p className="font-montserrat font-normal text-qw-gray text-sm mb-8">
            Please authenticate to access the fund facts platform.
          </p>
          <button
            onClick={() => instance?.loginRedirect()}
            className="qw-btn-primary w-full"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginRequired;
